import { Available } from "./Available";
import { Booked } from "./Booked";
import { BookedNotInUse } from "./BookedNotInUse";
import { AdHocUsage } from "./AdHocUsage";

export type MapIndicatorKey = keyof typeof MapIndicatorIllustration;

export const MapIndicatorIllustration = {
  Available,
  Booked,
  BookedNotInUse,
  AdHocUsage,
};
